import React from 'react';

import queryString from 'query-string';

import {
  Popup,
  EditableComponent,
  Loading,
} from 'arteia-js/components';
import { API } from 'arteia-js/services';
import { backgroundArtworks } from '../configs/backgroundArtworks.config';

var artwork =
  backgroundArtworks[Math.floor(Math.random() * backgroundArtworks.length)];
class EuLogin extends EditableComponent {
  state = {

    loginSuccessful: false,
    loginErrored: false,
    loading: false,

    errorCode: null,
    errorMessage: '',
    visible: true,

    redirectUrl: null,
  };

  ERROR_MESSAGES = {
    404: 'Email or password is not correct',
    401: 'Email or password is not correct',
    500: 'Something went wrong',
  };

  componentDidMount() {
    const { history } = this.props;

    if (this.returnPath() === '/') {
      return history.push('/login');
    }
    const { state } = history.location;
    if (!!state && !!state.errorMessage) {
      this.setState({
        errorMessage: state.errorMessage,
      });
    }

    //Execute Callback code process from EU-Login
    this.euLoginCallbackHandler();

  }

  goToLoginPage = () => {
    const { history } = this.props;
    return history.push('/login');
  };

  returnPath() {
    return window.location.pathname + window.location.search;
  }

  euLoginCallbackHandler = () => {
    this.setState({ loading: true });

    const { history } = this.props;
    const { returnTo,code } = queryString.parse(window.location.search);

    const returnToCollect = 'client';

    if(!code) {
      this.setState({
        loading: false,
        loginErrored: true,
        errorMessage: 'Auth Code is missing',
      });
    } else {

      //Passtrought callback params query returned form EU-Login (code, iss) to exchange code for token
      API.get(`/eu-login-callback${window.location.search}&returnTo=${returnToCollect}`).then((res) => {
      
        const query = {
          token: res.token,
          returnTo: returnToCollect,
        };
  
        this.setState({
          status: 200,
          errorCode: null,
        });
        return window.location.assign(
          `/redirect?${queryString.stringify(query)}`
        );
  
      })
      .catch((e) => {
        const { status } = e;
        this.setState({
          loading: false,
          loginErrored: true,
          errorCode: status,
          status,
          errorMessage: this.ERROR_MESSAGES[status] || this.ERROR_MESSAGES[500],
        });
      });

    }
    
  }


  render() {
    const { loading, errorMessage, status, visible } =
      this.state;

    return (
      <div
        className='login-form-wrapper'
        style={{ backgroundImage: `url(${artwork.asset})` }}
      >
        <div className='artwork-details'>
          <span className='artist-name'>{artwork.artistName}</span>
          <br />
          <span className='artwork-title'>
            {artwork.title}, {artwork.year}
          </span>
        </div>
        <span className='all-rights-reserved'>
          &copy; {new Date().getFullYear()} Arteïa - All rights reserved
        </span>
        <Popup
          size='form'
          noTitle
          noCloseHandler
          className='form login-form'
          loading={loading}
          visible={visible}
          loadingComponent={<Loading />}
        >
          <div className='popup-content'>
            <h1>Logging in to your account...</h1>

            <div className='form-msg'>
              <span className='error-msg'>
                {status !== 200 && errorMessage}
              </span>
            </div>
          </div>
          <a
            className='secondary-a'
            onClick={() => this.goToLoginPage()}
          >
            &lt; Back to Login page
          </a>
        </Popup>
      </div>
    );
  }
}

EuLogin.propTypes = {};
EuLogin.defaultProps = {};

export default EuLogin;



// WEBPACK FOOTER //
// ./src/scenes/EuLoginCallback/index.js